<template>
  <div class="responstivity">
    <div class="main">
      <div class="next-case cant-select" @click="nextSlide()">
        <img src="img/website/fast-forward.svg" alt="Seta para direita" loading = “lazy”/>
      </div>
      <div class="case-img">
        <transition name="pic-fade" mode="out-in">
          <div class="circle" :key="slide">
            <img :src="items[slide].image" alt="Foto do Case" loading = “lazy”/>
          </div>
        </transition>
      </div>
      <div class="case-info">
        <div class="title">
          Assim que<br />
          <span>transformamos</span><br />
          a vida de dentistas
        </div>
        <transition name="slide-fade" mode="out-in">
          <div class="infos" :key="slide">
            <p class="name">{{ items[slide].name }}</p>
            <div class="location">
              <img src="img/website/rocket.webp" alt="Foguete OdontoTop" loading = “lazy”/>
              <p>{{ items[slide].location }}</p>
            </div>

            <p class="call">
              Conheça a história
              {{ items[slide].gender == "male" ? "do" : "da" }}
              <span style="font-weight: 700">{{ items[slide].firstname }}</span>
            </p>

            <!-- <div class="timeline cant-select">
              <div
                class="time"
                v-for="(item, index) in items[slide].depoiments"
                :key="item.year"
                :class="{ active: index == spot }"
                @click="spot = index"
              >
                <span>{{ item.year }}</span>
              </div>
            </div> -->
            <transition name="depoiments-fade" mode="out-in">
              <div class="depoiment" :key="spot">
                {{
                  !items[slide].depoiments[spot]
                    ? ""
                    : items[slide].depoiments[spot].text
                }}
              </div>
            </transition>
          </div>
        </transition>
      </div>
    </div>
    <div class="next-case-mobile cant-select" @click="nextSlide()">
      <img src="img/website/fast-forward.svg" alt="Seta para direita" loading = “lazy”/>
    </div>
    <transition name="mobile-fade" mode="out-in">
      <div class="mobile-slide" :key="slide">
        <!-- <div class="mobile-timeline cant-select">
          <div
            class="time"
            v-for="(item, index) in items[slide].depoiments"
            :key="item.year"
            :class="{ active: index == spot }"
            @click="spot = index"
          >
            <span>{{ item.year }}</span>
          </div>
        </div> -->
        <transition name="depoiments-fade" mode="out-in">
          <div class="mobile-depoiment" :key="spot">
            {{
              !items[slide].depoiments[spot]
                ? ""
                : items[slide].depoiments[spot].text
            }}
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.responstivity {
  width: 100%;
  margin: 40px 0;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .main {
    width: 100%;
    display: flex;
    flex-direction: row;
    position: relative;
    .next-case {
      background-color: var(--blue);
      width: 70px;
      height: 270px;
      position: absolute;
      right: 3%;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.3s;
      &:hover {
        cursor: pointer;
        background-color: var(--dark-blue);
        img {
          animation: forward 1s cubic-bezier(0.45, 0.91, 0.55, 0.55) infinite;
        }
      }
      @media (max-width: 1440px) {
        width: 60px;
        height: 260px;
      }
      @media (max-width: 1024px) {
        width: 50px;
        height: 250px;
      }
      @media (max-width: 768px) {
        &:hover {
          background-color: var(--blue);
          img {
            animation: none;
          }
        }
      }
      @media (max-width: 480px) {
        display: none;
      }
    }
    .case-img {
      width: 40%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .pic-fade-enter-active,
      .pic-fade-leave-active {
        transition: all 0.5s ease-in-out;
      }
      .pic-fade-enter,
      .pic-fade-leave-to {
        opacity: 0;
      }
      .circle {
        width: 500px;
        height: 500px;
        background-color: var(--cta-yellow);
        border-radius: 100%;
        transform: translateY(10%);
        z-index: -1;
        @media screen and (max-width: 550px) {
          transform: translate(-10%, -20%);
        }
        img {
          transform: translate(-2%, -25%);
          width: 440px;
          height: 550px;
          object-fit: cover;
          object-position: top center;
          @media screen and (max-width: 550px) {
            transform: translate(20%, 14%) !important;
          }
        }
        @media (max-width: 1440px) {
          height: 350px;
          width: 350px;
          img {
            width: 300px;
            height: 370px;
          }
        }
        @media (max-width: 1024px) {
          height: 250px;
          width: 250px;
          img {
            transform: translate(0%, -15%);
            width: 200px;
            height: 250px;
          }
        }
        @media (max-width: 480px) {
          height: 180px;
          width: 180px;
          img {
            transform: translate(-5%, -25%);
            width: 160px;
            height: 199px;
          }
        }
      }
    }
    .case-info {
      width: 60%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      padding-right: 5%;
      .slide-fade-enter-active,
      .slide-fade-leave-active {
        transition: all 0.5s ease-in-out;
      }
      .slide-fade-enter,
      .slide-fade-leave-to {
        opacity: 0;
      }
      .title {
        font-size: 42px;
        span {
          font-size: 64px;
          line-height: 64px;
        }
      }
      .infos {
        margin-top: 3%;
        width: 100%;
        .name {
          font-size: 48px;
          line-height: 56px;
          font-weight: 700;
          color: var(--blue);
          text-transform: uppercase;
          @media (max-width: 1440px) {
            font-size: 32px;
            line-height: 40px;
          }
          @media (max-width: 1024px) {
            font-size: 28px;
            line-height: 30px;
          }
          @media (max-width: 480px) {
            font-size: 18px;
            word-wrap: break-word;
          }
        }
        .location {
          display: inline-flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          p {
            font-weight: 700;
            font-size: 24px;
            color: var(--blue);
          }
          img {
            width: 34px;
          }
          @media (max-width: 1440px) {
            p {
              font-size: 20px;
            }
          }
          @media (max-width: 1024px) {
            p {
              font-size: 18px;
            }
            img {
              width: 28px;
            }
          }
        }
        .call {
          margin: 3% 0;
          font-size: 24px;
          font-weight: 300;
          color: var(--gray);
          @media (max-width: 1440px) {
            font-size: 20px;
          }
          @media (max-width: 1024px) {
            font-size: 18px;
          }
        }
        .timeline {
          margin: 5% 0;
          padding: 0 5%;
          width: 85%;
          height: 12px;
          background-color: var(--cta-yellow);
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          @media (max-width: 1440px) {
            height: 10px;
          }
          @media (max-width: 1024px) {
            height: 8px;
          }
          @media (max-width: 768px) {
            display: none;
          }
          .time {
            width: 34px;
            height: 34px;
            background-color: var(--cta-yellow);
            color: var(--white-text);
            border-radius: 100%;
            transition: all 0.5s;
            &:hover {
              background-color: var(--dark-cta-yellow);
              cursor: pointer;
            }
            span {
              display: none;
            }
            @media (max-width: 1440px) {
              height: 28px;
              width: 28px;
            }
            @media (max-width: 1024px) {
              height: 24px;
              width: 24px;
            }
          }
          .time.active {
            background-color: var(--blue);
            color: var(--white-text);
            border-radius: 8px;
            width: 86px;
            display: flex;
            justify-content: center;
            align-items: center;
            &:hover {
              cursor: default;
            }
            span {
              display: block;
              font-size: 18px;
              font-weight: 700;
            }
          }
        }
        .depoiment {
          width: 85%;
          font-size: 24px;
          font-weight: 300;
          line-height: 32px;
          color: var(--gray);
          visibility: visible;
          opacity: 1;
          @media (max-width: 1440px) {
            font-size: 20px;
          }
          @media (max-width: 1440px) {
            font-size: 18px;
            line-height: 24px;
          }
          @media (max-width: 768px) {
            display: none;
          }
        }
        .depoiment.inative {
          visibility: hidden;
          opacity: 0;
        }
        .depoiments-fade-enter-active,
        .depoiments-fade-leave-active {
          transition: all 0.3s ease-in-out;
        }
        .depoiments-fade-enter,
        .depoiments-fade-leave-to {
          opacity: 0;
        }
        @media (max-width: 1024px) {
          margin-top: 2%;
        }
      }
      @media (max-width: 1024px) {
        .title span {
          font-size: 52px;
          line-height: 52px;
        }
      }
      @media (max-width: 900px) {
        .title {
          font-size: 36px;
          span {
            font-size: 42px;
            line-height: 42px;
          }
        }
      }
      @media (max-width: 768px) {
        padding-right: calc(5% + 50px);
        .title {
          font-size: 32px;
          line-height: 32px;
          margin-bottom: 10px !important;
          span {
            font-size: 38px;
            line-height: 38px;
          }
        }
        .infos {
          margin-top: 10px;
        }
      }
      @media (max-width: 480px) {
        padding-right: 0;
        .title {
          font-size: 24px;
          line-height: 24px;
          span {
            font-size: 32px;
            line-height: 32px;
          }
        }
      }
    }
  }
  .next-case-mobile {
    background-color: var(--blue);
    width: 270px;
    height: 40px;
    margin: 5% 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s;
    @media (min-width: 481px) {
      display: none;
    }
  }
  .mobile-fade-enter-active,
  .mobile-fade-leave-active {
    transition: all 0.5s ease-in-out;
  }
  .mobile-fade-enter,
  .mobile-fade-leave-to {
    opacity: 0;
  }
  .mobile-slide {
    .mobile-depoiment {
      width: 85%;
      margin: 0 auto;
      font-size: 24px;
      font-weight: 300;
      line-height: 32px;
      color: var(--gray);
      opacity: 1;
      padding-top: 10px;
      visibility: visible;
      .depoiment.inative {
        visibility: hidden;
        opacity: 0;
      }
      @media (min-width: 769px) {
        display: none;
      }
      @media (max-width: 480px) {
        font-size: 18px;
        line-height: 24px;
      }
    }
    .depoiments-fade-enter-active,
    .depoiments-fade-leave-active {
      transition: all 0.3s ease-in-out;
    }
    .depoiments-fade-enter,
    .depoiments-fade-leave-to {
      opacity: 0;
    }
    .mobile-timeline {
      margin: 5% auto;
      padding: 0 5%;
      width: 85%;
      height: 12px;
      background-color: var(--cta-yellow);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      @media (min-width: 769px) {
        display: none;
      }
      @media (max-width: 480px) {
        margin: 10% auto 5%;
        width: 95%;
      }
      .time {
        width: 34px;
        height: 34px;
        background-color: var(--cta-yellow);
        color: var(--white-text);
        border-radius: 100%;
        transition: all 0.5s;
        &:hover {
          background-color: var(--dark-cta-yellow);
          cursor: pointer;
        }
        span {
          display: none;
        }
      }
      .time.active {
        background-color: var(--blue);
        color: var(--white-text);
        border-radius: 8px;
        width: 86px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          cursor: default;
        }
        span {
          display: block;
          font-size: 18px;
          font-weight: 700;
        }
      }
    }
  }
  @media (max-width: 700px) {
    padding-top: 5%;
    .main {
      flex-wrap: wrap;
      .case-img,
      .case-info {
        margin-bottom: 15px;
        padding: 0 5%;
        width: 100%;
      }
    }
  }
}
</style>

<script>
export default {
  props: ["franchisees"],
  data() {
    return {
      items: [],
      spot: 0,
      slide: 0,
    };
  },

  created() {
    this.items = JSON.parse(this.franchisees);
  },

  methods: {
    nextSlide() {
      this.slide == this.items.length - 1
        ? (this.slide = 0)
        : (this.slide += 1);
      this.spot = 0;
    },
  },
};
</script>